import React, { type ReactNode } from 'react';

import { BFFConsumerEnum, BFFProvider } from '@atlassian/navigation-bff-data-provider';
import { ConditionalRelayEnvironmentProvider } from '@atlassian/relay-environment-provider';

export function MenuWrapper({ children }: { children: ReactNode }) {
	return (
		<ConditionalRelayEnvironmentProvider>
			<BFFProvider consumer={BFFConsumerEnum.UNIVERSAL_CREATE}>
				{children}
			</BFFProvider>
		</ConditionalRelayEnvironmentProvider>);
}
